import React, { useState } from "react"
import { Col, Row } from "reactstrap"
import toast from "react-hot-toast"
import { Link, useParams, useHistory } from "react-router-dom"

import eyeIcon from "../../../assets/images/icons/eye-icon.svg"
import editIcon from "../../../assets/images/icons/edit-icon.svg"
import DeleteIcon from "assets/images/icons/finance-vendor-mang-del-icon.svg"

import ActiveInactiveSwitch from "../../Configurator/CommonUI/ActiveInactiveSwitch/ActiveInactiveSwitch"
import { DataTable } from "../../../components/DataTable"
import { useLocalPaginatedRequest } from "../../../hooks/useLocalPaginatedRequest"
import { Pagination } from "../../../components/Pagination"
import {
   DeleteEquipmentCategoryItem,
   GetEquipmentsCategoryItemsListing,
   UpdateEquipmentCategoryItems,
   UpdateGlobalEquipmentCategorySequence,
} from "../../../api/api.service"
import { SearchBox } from "../../../components/SearchBox"
import { Button } from "../../../components/Button"
import { AutoComplete } from "../../../components/AutoComplete"
import { EquipmentCategoryItemsStatus, SortOrder } from "../../../constants"
import {
   convertToSelectOptions,
   replaceSlashes,
} from "../../../utils/commonUtils"
import { convertDateTime, dateTimeFormat } from "utils/dateFormatUtils"
import ManageGlobalEquipmentsCategoryItems from "./ManageGlobalEquipmentsCategoryItems"
import DeleteModal from "../../Configurator/CommonUI/Modal/DeleteModal"
import autoCompleteStyles from "components/AutoComplete/autoCompleteStyles"
import { APP_ROUTES } from "helpers/routeHelpers"
import TruncatedTextWithTooltip from "components/CustomTooltip/CustomTooltip"
import useRenderUsedIn from "hooks/useRenderUsedIn"
import { DragDropContext, Droppable } from "react-beautiful-dnd"

const COLUMNS = {
   ITEM_NAME: "Item",
   PRICE: "Price",
   DATE_EDITED: "Date edited",
   STATUS: "Status",
   USED_IN: "Used In",
   ACTIONS: "Actions",
}
const DATA_KEY = "data"
const TOTAL_KEY = "total"
const INFINITE_LIMIT_COUNT = -1

const GlobalEquipmentCategoryItems = ({}) => {
   const { categoryName } = useParams()
   const [statusFilters, setStatusFilters] = useState(null)
   const [selection, setSelection] = useState(null)
   const [openDelModal, setOpenDelModal] = useState(false)

   const {
      data,
      isFetching,
      page,
      searchText,
      pageSize,
      total,
      handleSearchChange,
      request,
      handlePageClick,
      onChangePageSize,
      setTableDataChangeLoading,
      tableDataChangeLoading,
      setData,
   } = useLocalPaginatedRequest({
      requestFn: GetEquipmentsCategoryItemsListing,
      params: {
         page: 1,
         limit: INFINITE_LIMIT_COUNT,
         direction: SortOrder.ASC,
         column: "sequenceNo",
         ...(statusFilters?.value && { status: statusFilters?.value }),
      },
      deps: [statusFilters],
      dataKey: DATA_KEY,
      totalKey: TOTAL_KEY,
   })

   const [eventsType, setEventsType] = useState({
      isManage: null,
      isUpdate: null,
      isDetails: null,
   })

   const handleInitManage = (obj = null) => {
      setEventsType(prev => ({ ...prev, isManage: true }))
      setSelection(obj)
   }

   const handleInitViewDetails = (obj = null) => {
      setSelection(obj)
      setEventsType(prev => ({ ...prev, isDetails: true, isManage: true }))
   }

   const handleSelectStatusOption = option => {
      setStatusFilters(option)
   }

   const handleStatusChange = async (currStatus, id) => {
      let status =
         currStatus === EquipmentCategoryItemsStatus.Active
            ? EquipmentCategoryItemsStatus.Inactive
            : EquipmentCategoryItemsStatus.Active
      let dataClone = [...data]
      dataClone.map(el => {
         if (el?.id == id) el.status = status
      })
      setData(dataClone)
      let payload = {
         status: status,
      }
      try {
         setTableDataChangeLoading(true)
         let res = await UpdateEquipmentCategoryItems(id, payload)
         toast.success("Item status has been updated !")
      } catch (err) {
         toast.error(err.message)
         let dataClone = [...data]
         dataClone.map(el => {
            if (el?.id == id) el.status = currStatus
         })
         setData(dataClone)
      } finally {
         setTableDataChangeLoading(false)
      }
   }

   const handleInitDelete = obj => {
      setSelection(obj)
      setOpenDelModal(prev => !prev)
   }

   const renderUsedIn = useRenderUsedIn({
      listKey: "usedInTrailers",
   })

   const handleDragEnd = async result => {
      if (!result.destination) return

      const items = Array.from(data)
      const [reorderedItem] = items.splice(result.source.index, 1)
      items.splice(result.destination.index, 0, reorderedItem)

      setData(items)

      let payload = {
         sequenceItems: items.map((trailerObj, ind) => ({
            id: Number(trailerObj.id),
            sequenceNo: ind,
         })),
      }

      try {
         await UpdateGlobalEquipmentCategorySequence(payload)
         toast.success("Sequence updated successfully!")
      } catch (err) {
         toast.error("Failed to update sequence")
      }
   }

   return (
      <>
         <div className="d-flex align-items-center gap-1 ">
            <Link to={APP_ROUTES.CONFIGURATOR_TRAILERS}>
               <div className="d-flex align-items-center gap-2 configurator-top-link">
                  {"< Configurator Settings"}
                  <span className="configurator-global-arrow">&gt;</span>
               </div>
            </Link>
            <Link
               to={APP_ROUTES.CONFIGURATOR_TRAILER_SETTINGS_GLOBAL_EQUIPMENTS}
            >
               <div className="d-flex align-items-center configurator-top-link">
                  Equipments
               </div>
            </Link>
         </div>
         <h3 className="configurator-global-heading mt-2">Equipments</h3>
         <div className="mb-3 trailer-container">
            <div className="d-flex align-items-center justify-content-between admin-inventory-management-general-inventory-responsiveness trailer-btn-container">
               <h3 className="configurator-global-heading">
                  {replaceSlashes(categoryName)}
               </h3>
               <div />

               <Button
                  className={`header-button headerButtonResponsive`}
                  title="Add Item"
                  onClick={() => handleInitManage({})}
               />
            </div>
         </div>

         <div className="mb-3">
            <div className="d-flex align-items-center justify-content-between admin-inventory-management-general-inventory-responsiveness ">
               <div className="status-search-con wh-im-dpgi-status  me-2 ">
                  <AutoComplete
                     value={statusFilters}
                     isClearable
                     onChange={val => handleSelectStatusOption(val)}
                     isSearchable={false}
                     placeholder="Select status"
                     customStyles={autoCompleteStyles.STYLE_SIX}
                     classNamePrefix="status-header-search-admin"
                     options={convertToSelectOptions(
                        EquipmentCategoryItemsStatus
                     )}
                  />
               </div>
               <div className="ad-location-search-box">
                  <SearchBox
                     inputClasses="vendor-search-input input-search"
                     labelClass="d-none"
                     placeholder="Search"
                     searchIcon={true}
                     searchIconClass="custom-input-search-icon"
                     conClass={`search-input-container-class`}
                     searchText={searchText}
                     onChange={handleSearchChange}
                  />
               </div>
            </div>
         </div>
         <Row>
            <Col md={12}>
               <DragDropContext onDragEnd={handleDragEnd}>
                  <Droppable droppableId="droppable">
                     {provided => (
                        <div
                           {...provided.droppableProps}
                           ref={provided.innerRef}
                        >
                           <DataTable
                              data={data}
                              isDraggable={true}
                              droppablePlaceholder={provided.placeholder}
                              tableClasses="equipment-category-table"
                              loading={isFetching}
                              config={[
                                 {
                                    title: COLUMNS.ITEM_NAME,
                                    className: "",
                                    render: data => {
                                       return (
                                          <TruncatedTextWithTooltip
                                             text={data.name}
                                          />
                                       )
                                    },
                                 },
                                 {
                                    title: COLUMNS.PRICE,
                                    className: "",
                                    render: data => "$" + data?.price || "-",
                                 },
                                 {
                                    title: COLUMNS.DATE_EDITED,
                                    className: "",
                                    render: data => {
                                       return convertDateTime({
                                          date: data.updatedAt,
                                          customFormat:
                                             dateTimeFormat.casitaCustomDateFormat,
                                          dateOnly: true,
                                          local: true,
                                       })
                                    },
                                 },
                                 {
                                    title: COLUMNS.USED_IN,
                                    className: "",
                                    render: renderUsedIn,
                                 },

                                 {
                                    title: COLUMNS.STATUS,
                                    className: "",
                                    render: data => (
                                       <ActiveInactiveSwitch
                                          isDisable={tableDataChangeLoading}
                                          id={data.id}
                                          name={`${data.id}`}
                                          onChange={e =>
                                             handleStatusChange(
                                                data?.status,
                                                data?.id
                                             )
                                          }
                                          isChecked={
                                             data?.status ==
                                             EquipmentCategoryItemsStatus.Active
                                          }
                                       />
                                    ),
                                 },

                                 {
                                    title: COLUMNS.ACTIONS,

                                    render: data => (
                                       <div className="d-flex gap-2 pointer">
                                          <img
                                             src={eyeIcon}
                                             onClick={() =>
                                                handleInitViewDetails(data)
                                             }
                                          />

                                          <img
                                             src={editIcon}
                                             onClick={() =>
                                                handleInitManage(data)
                                             }
                                          />
                                          <img
                                             src={DeleteIcon}
                                             onClick={() =>
                                                handleInitDelete(data)
                                             }
                                          />
                                       </div>
                                    ),
                                 },
                              ]}
                           />{" "}
                        </div>
                     )}
                  </Droppable>
               </DragDropContext>

               {/* <Pagination
               currentPage={page}
               totalData={total}
               onPageClick={handlePageClick}
               rowLimit={pageSize}
               onChangePageSize={onChangePageSize}
            /> */}
            </Col>
         </Row>
         {Object.values(eventsType).includes(true) && (
            <ManageGlobalEquipmentsCategoryItems
               isUpdating={Boolean(eventsType.isManage && selection)}
               isDetailView={eventsType.isDetails}
               isOpen={eventsType.isManage}
               id={selection?.id}
               onSuccess={request}
               onToggleModal={() => {
                  setSelection(null)
                  setEventsType(prev => ({
                     ...prev,
                     isManage: false,
                     isDetails: false,
                  }))
               }}
            />
         )}
         <DeleteModal
            isOpen={openDelModal}
            toggleFunction={setOpenDelModal}
            id={selection?.id}
            apiFunction={DeleteEquipmentCategoryItem}
            title={"Equipment Item"}
            requestFunction={request}
         />
      </>
   )
}

export default GlobalEquipmentCategoryItems
